import { z } from "zod";
// Contact information schema
export const ContactInfoSchema = z.object({
    name: z.string(),
    email: z.string().email().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
});
// Liveness signal types
export var LivenessSignalType;
(function (LivenessSignalType) {
    LivenessSignalType["ACTIVE_CHECKIN"] = "active_checkin";
    LivenessSignalType["SOCIAL_MEDIA"] = "social_media";
    LivenessSignalType["DEVICE_ACTIVITY"] = "device_activity";
    LivenessSignalType["BIOMETRIC"] = "biometric";
    LivenessSignalType["LOCATION"] = "location";
})(LivenessSignalType || (LivenessSignalType = {}));
export const LivenessSignalSchema = z.object({
    type: z.nativeEnum(LivenessSignalType),
    name: z.string(),
    description: z.string(),
    weight: z.number().min(0).max(1), // Confidence weight (0-1)
    required: z.boolean(),
    timeout: z.object({
        value: z.number(),
        unit: z.enum(["seconds", "minutes", "hours", "days"]),
    }),
});
// Escalation timeline for triggers
export const EscalationTimelineSchema = z.object({
    name: z.string(),
    delay: z.object({
        value: z.number(),
        unit: z.enum(["seconds", "minutes", "hours", "days"]),
    }), // Time after trigger activation
    actions: z.array(z.string()), // Action names to execute
    requiresConfirmation: z.boolean(),
});
// Liveness status
export var LivenessStatus;
(function (LivenessStatus) {
    LivenessStatus["ALIVE"] = "alive";
    LivenessStatus["WARNING"] = "warning";
    LivenessStatus["TRIGGERED"] = "triggered";
    LivenessStatus["RESET"] = "reset";
})(LivenessStatus || (LivenessStatus = {}));
//# sourceMappingURL=index.js.map